import { compose, hoistStatics, withState, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { userActions } from '../../reducers/user';
import { authActions } from '../../reducers/auth';
import { permissionsActions } from '../../reducers/permissions';
import * as wsOperations from '../../reducers/websockets/operations';

import CheckEmail2fa from './CheckEmail2fa';
import { getLoginCover } from '../../helpers/auth.helper';
import dh from '../../helpers/defaultImages.helper';

const mapStateToProps = state => ({
  loginColor: state.settings.subscriber.login_color,
  coverLogin: state.settings.subscriber.cover_login,
  canRegister: !!state.settings.subscriber.can_register,
  loginLayout: state.settings.subscriber.login_layout || 1,
  socialLoginLayout: state.settings.subscriber ? state.settings.subscriber.login_modules_theme : 1,
});

const mapDispatchToProps = {
  setUser: userActions.setUser,
  setToken: authActions.setToken,
  setPermissions: permissionsActions.setPermissions,
  connectSocketToServer: wsOperations.connectSocketToServer,
  subscribeToChannel: wsOperations.subscribeToChannel,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate('portal'),
  withState('code', 'setCode', ''),
  withState('errors', 'setErrors', {}),
  withState('isSubmitting', 'setIsSubmitting', false),
  withProps(props => ({
    cover: getLoginCover(props) || dh.defaultLogin,
  })),
);

export default withRouter(hoistStatics(enhance)(CheckEmail2fa));



// WEBPACK FOOTER //
// ./src/views/checkEmail2fa/index.js